// Medición: Google Analytics 4 (gtag.js) + Meta Pixel, cargados asíncronos.
// Los IDs viven en frontend/.env (REACT_APP_GA4_ID, REACT_APP_META_PIXEL_ID).
// Mientras los IDs sean marcadores (XXXX / ceros), no se carga ningún script externo.
const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

const usable = (id) => Boolean(id) && !/X{4,}/i.test(id) && !/^0+$/.test(id.trim());
export const GA4_ON = usable(GA4_ID);
export const PIXEL_ON = usable(PIXEL_ID);

export const initAnalytics = () => {
  if (GA4_ON && !window.dataLayer) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    // page_view se envía manual por ruta (send_page_view:false) para no duplicar con el envío manual
    window.gtag("config", GA4_ID, { send_page_view: false });
  }
  if (PIXEL_ON && !window.fbq) {
    const n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    const t = document.createElement("script");
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(t);
    window.fbq("init", PIXEL_ID); // PageView manual por ruta, sin evento automático
  }
};

let lastPath = null;
export const trackPageView = (path) => {
  if (path === lastPath) return;
  lastPath = path;
  if (GA4_ON && window.gtag) window.gtag("event", "page_view", { page_path: path, page_title: document.title });
  if (PIXEL_ON && window.fbq) window.fbq("track", "PageView");
  console.debug("[medicion] page_view", path);
};

// GA4: evento custom · Meta: evento estándar (p. ej. "Contact", "Lead")
export const trackEvent = (name, params = {}, metaName = "", metaParams = {}) => {
  if (GA4_ON && window.gtag) window.gtag("event", name, params);
  if (metaName && PIXEL_ON && window.fbq) window.fbq("track", metaName, metaParams);
  console.debug("[medicion]", name, params, metaName || "");
};
